import { useEffect, useState } from "react";
import Label from "../../../../../components/label/Label";
import ShowMore from "../../../../../components/showMore";
import "./index.scss";

const ProjectExperience = ({ projectExperienceData }) => {
    const defaultItemsToShow = 3;
    const [itemsToShow, setItemsToShow] = useState(defaultItemsToShow);
    const [projectExperienceList, setProjectExperienceList] = useState([]);

    useEffect(() => {
        if (projectExperienceData && Array.isArray(projectExperienceData)) {
            setProjectExperienceList(
                [...projectExperienceData].sort((a, b) => {
                    return a.description && !b.description ? -1 : 1;
                })
            );
        }
    }, [projectExperienceData]);

    const showMore = () => {
        const projectCount =
            projectExperienceData && Array.isArray(projectExperienceData)
                ? projectExperienceData.length
                : 0;
        itemsToShow === defaultItemsToShow
            ? setItemsToShow(projectCount)
            : setItemsToShow(defaultItemsToShow);
    };

    return (
        projectExperienceList.length > 0 && (
            <div className="freelancerModalComponentWrap">
                <Label
                    label="Project Examples"
                    className="font18Black boldFont sectionTitleWrapper"
                />
                {projectExperienceList
                    ?.slice(0, itemsToShow)
                    .map((data, index) => {
                        return (
                            <div key={index} className="projectWrapper">
                                <div className="projectTitle">
                                    {data?.role
                                        ? `${data?.client} | ${data?.role}`
                                        : data?.client}
                                </div>

                                <div className="projectName">
                                    {data?.projectName}
                                </div>

                                {data?.description?.length > 0 && (
                                    <ShowMore
                                        text={data?.description.trim()}
                                        more="More"
                                        less="Less"
                                        textClass="font14Grey"
                                        anchorClass="font14Blue noWrap"
                                        lines={3}
                                        lineHeight={21}
                                        id={`projectExperience${index}`}
                                    />
                                )}
                            </div>
                        );
                    })}

                {projectExperienceList?.length > defaultItemsToShow && (
                    <>
                        <div className="mb-3" />
                        <div
                            className="font14Blue text-align-center"
                            onClick={showMore}
                        >
                            {itemsToShow !== defaultItemsToShow
                                ? "Less"
                                : "More"}
                        </div>
                    </>
                )}
            </div>
        )
    );
};

export default ProjectExperience;
